// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.organizasyon-semasi-page {
  padding: 20px;
}

.organizasyon-semasi-page.dark {
  background-color: var(--dark-bg);
  color: var(--dark-text);
}

.organizasyon-semasi-page.light {
  background-color: var(--color-bg);
  color: var(--color-text);
}

.orgwrap {
  position: relative;
  background: white;
  border-radius: 8px;
  padding: 20px;
  min-height: 500px;
}

.organizasyon-semasi-page.dark .orgwrap {
  background: var(--dark-bg-secondary);
}

.zoom-controls {
  position: absolute;
  top: 30px;
  right: 30px;
  z-index: 10;
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.9);
  padding: 8px;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.organizasyon-semasi-page.dark .zoom-controls {
  background: rgba(30, 30, 30, 0.9);
}

.zoom-container {
  position: relative;
  width: 100%;
  height: 500px;
  overflow: hidden;
  background: white;
  border-radius: 4px;
  touch-action: none;
}

.organizasyon-semasi-page.dark .zoom-container {
  background: var(--dark-bg-secondary);
}

.mermaid-wrapper {
  position: relative;
  width: fit-content;
  height: fit-content;
}

#tree-view {
  width: 100%;
  min-height: 400px;
}

.firmabox {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
}

.firmacolor {
  margin-bottom: 5px;
  padding: 4px 8px;
  font-size: 12px;
  border-radius: 6px;
  text-align: center;
  font-weight: 600;
}

/* Mermaid diagram stilleri */
.mermaid {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Firma renkleri için özel stiller */
.organizasyon-semasi-page .mermaid .node rect,
.organizasyon-semasi-page .mermaid .node circle,
.organizasyon-semasi-page .mermaid .node ellipse,
.organizasyon-semasi-page .mermaid .node polygon {
  stroke-width: 2px;
}

/* Dark modeda da metin rengi siyah kalmalı  */
.organizasyon-semasi-page .mermaid svg text,
.organizasyon-semasi-page .mermaid svg .nodeLabel,
.organizasyon-semasi-page .mermaid svg .label,
.organizasyon-semasi-page .mermaid svg .node-label,
.organizasyon-semasi-page .mermaid svg tspan,
.organizasyon-semasi-page .mermaid svg .label text,
.organizasyon-semasi-page .mermaid svg .nodeLabel text {
  fill: #000000 !important;
  color: #000000 !important;
}

/* Dark mode için özel override */
.organizasyon-semasi-page.dark .mermaid svg text,
.organizasyon-semasi-page.dark .mermaid svg .nodeLabel,
.organizasyon-semasi-page.dark .mermaid svg .label,
.organizasyon-semasi-page.dark .mermaid svg .node-label,
.organizasyon-semasi-page.dark .mermaid svg tspan,
.organizasyon-semasi-page.dark .mermaid svg .label text,
.organizasyon-semasi-page.dark .mermaid svg .nodeLabel text {
  fill: #000000 !important;
  color: #000000 !important;
}

/* Dark mode da da metin rengi siyah kalmalı */
.organizasyon-semasi-page .mermaid svg text,
.organizasyon-semasi-page .mermaid svg .nodeLabel,
.organizasyon-semasi-page .mermaid svg .label,
.organizasyon-semasi-page .mermaid svg .node-label,
.organizasyon-semasi-page .mermaid svg tspan {
  fill: #000000 !important;
  color: #000000 !important;
}

/* Mermaid in dark theme yı override et */
.organizasyon-semasi-page.dark .mermaid svg text,
.organizasyon-semasi-page.dark .mermaid svg .nodeLabel,
.organizasyon-semasi-page.dark .mermaid svg .label,
.organizasyon-semasi-page.dark .mermaid svg .node-label,
.organizasyon-semasi-page.dark .mermaid svg tspan {
  fill: #000000 !important;
  color: #000000 !important;
}

/* Node action icons overlay */
.node-icons-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 10;
}

/* Profile image wrapper */
.node-image-wrapper {
  pointer-events: auto;
}

.node-profile-image {
  width: 50px;
  height: 50px;
  border-radius: 8px;
  object-fit: cover;
  border: 2px solid #000;
  background: #f0f0f0;
  display: block;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.node-profile-placeholder {
  width: 50px;
  height: 50px;
  border-radius: 8px;
  border: 2px solid #000;
  background: #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  color: #666;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* Icon wrapper */
.node-icon-wrapper {
  display: flex;
  gap: 8px;
  pointer-events: auto;
}

.node-action-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid #000;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  width: 24px;
  height: 24px;
}

.node-action-button:hover {
  background: rgba(240, 240, 240, 0.95) !important;
  transform: scale(1.1);
}

.node-action-button svg {
  color: #000;
}

/* Responsive */
@media (max-width: 768px) {
  .firmabox {
    width: 100%;
    margin-top: 10px;
  }
  
  .orgwrap {
    padding: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/organizasyon/OrganizasyonSemasiPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;;;;EAIE,iBAAiB;AACnB;;AAEA,8CAA8C;AAC9C;;;;;;;EAOE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;;;;;;;EAOE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA,8CAA8C;AAC9C;;;;;EAKE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA,yCAAyC;AACzC;;;;;EAKE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,wCAAwC;AAC1C;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gDAAgD;EAChD,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA,eAAe;AACf;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".organizasyon-semasi-page {\n  padding: 20px;\n}\n\n.organizasyon-semasi-page.dark {\n  background-color: var(--dark-bg);\n  color: var(--dark-text);\n}\n\n.organizasyon-semasi-page.light {\n  background-color: var(--color-bg);\n  color: var(--color-text);\n}\n\n.orgwrap {\n  position: relative;\n  background: white;\n  border-radius: 8px;\n  padding: 20px;\n  min-height: 500px;\n}\n\n.organizasyon-semasi-page.dark .orgwrap {\n  background: var(--dark-bg-secondary);\n}\n\n.zoom-controls {\n  position: absolute;\n  top: 30px;\n  right: 30px;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.9);\n  padding: 8px;\n  border-radius: 6px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n.organizasyon-semasi-page.dark .zoom-controls {\n  background: rgba(30, 30, 30, 0.9);\n}\n\n.zoom-container {\n  position: relative;\n  width: 100%;\n  height: 500px;\n  overflow: hidden;\n  background: white;\n  border-radius: 4px;\n  touch-action: none;\n}\n\n.organizasyon-semasi-page.dark .zoom-container {\n  background: var(--dark-bg-secondary);\n}\n\n.mermaid-wrapper {\n  position: relative;\n  width: fit-content;\n  height: fit-content;\n}\n\n#tree-view {\n  width: 100%;\n  min-height: 400px;\n}\n\n.firmabox {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.firmacolor {\n  margin-bottom: 5px;\n  padding: 4px 8px;\n  font-size: 12px;\n  border-radius: 6px;\n  text-align: center;\n  font-weight: 600;\n}\n\n/* Mermaid diagram stilleri */\n.mermaid {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* Firma renkleri için özel stiller */\n.organizasyon-semasi-page .mermaid .node rect,\n.organizasyon-semasi-page .mermaid .node circle,\n.organizasyon-semasi-page .mermaid .node ellipse,\n.organizasyon-semasi-page .mermaid .node polygon {\n  stroke-width: 2px;\n}\n\n/* Dark modeda da metin rengi siyah kalmalı  */\n.organizasyon-semasi-page .mermaid svg text,\n.organizasyon-semasi-page .mermaid svg .nodeLabel,\n.organizasyon-semasi-page .mermaid svg .label,\n.organizasyon-semasi-page .mermaid svg .node-label,\n.organizasyon-semasi-page .mermaid svg tspan,\n.organizasyon-semasi-page .mermaid svg .label text,\n.organizasyon-semasi-page .mermaid svg .nodeLabel text {\n  fill: #000000 !important;\n  color: #000000 !important;\n}\n\n/* Dark mode için özel override */\n.organizasyon-semasi-page.dark .mermaid svg text,\n.organizasyon-semasi-page.dark .mermaid svg .nodeLabel,\n.organizasyon-semasi-page.dark .mermaid svg .label,\n.organizasyon-semasi-page.dark .mermaid svg .node-label,\n.organizasyon-semasi-page.dark .mermaid svg tspan,\n.organizasyon-semasi-page.dark .mermaid svg .label text,\n.organizasyon-semasi-page.dark .mermaid svg .nodeLabel text {\n  fill: #000000 !important;\n  color: #000000 !important;\n}\n\n/* Dark mode da da metin rengi siyah kalmalı */\n.organizasyon-semasi-page .mermaid svg text,\n.organizasyon-semasi-page .mermaid svg .nodeLabel,\n.organizasyon-semasi-page .mermaid svg .label,\n.organizasyon-semasi-page .mermaid svg .node-label,\n.organizasyon-semasi-page .mermaid svg tspan {\n  fill: #000000 !important;\n  color: #000000 !important;\n}\n\n/* Mermaid in dark theme yı override et */\n.organizasyon-semasi-page.dark .mermaid svg text,\n.organizasyon-semasi-page.dark .mermaid svg .nodeLabel,\n.organizasyon-semasi-page.dark .mermaid svg .label,\n.organizasyon-semasi-page.dark .mermaid svg .node-label,\n.organizasyon-semasi-page.dark .mermaid svg tspan {\n  fill: #000000 !important;\n  color: #000000 !important;\n}\n\n/* Node action icons overlay */\n.node-icons-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 10;\n}\n\n/* Profile image wrapper */\n.node-image-wrapper {\n  pointer-events: auto;\n}\n\n.node-profile-image {\n  width: 50px;\n  height: 50px;\n  border-radius: 8px;\n  object-fit: cover;\n  border: 2px solid #000;\n  background: #f0f0f0;\n  display: block;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.node-profile-placeholder {\n  width: 50px;\n  height: 50px;\n  border-radius: 8px;\n  border: 2px solid #000;\n  background: #e0e0e0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  font-weight: bold;\n  color: #666;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n/* Icon wrapper */\n.node-icon-wrapper {\n  display: flex;\n  gap: 8px;\n  pointer-events: auto;\n}\n\n.node-action-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.95);\n  border: 1px solid #000;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s;\n  width: 24px;\n  height: 24px;\n}\n\n.node-action-button:hover {\n  background: rgba(240, 240, 240, 0.95) !important;\n  transform: scale(1.1);\n}\n\n.node-action-button svg {\n  color: #000;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .firmabox {\n    width: 100%;\n    margin-top: 10px;\n  }\n  \n  .orgwrap {\n    padding: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
